import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=0631ea15"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports